import { Reveal } from "./Reveal";

export const SectionHeading = ({ chapter, overline, title, description, dark = false, center = false }) => (
  <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""} mb-14 md:mb-20`}>
    <div className={`flex items-center gap-4 mb-5 ${center ? "justify-center" : ""}`}>
      {chapter && (
        <span className={`font-serif italic text-lg ${dark ? "text-gold/70" : "text-gold-muted"}`}>
          {chapter}
        </span>
      )}
      <span className="h-px w-10 bg-gold/60" aria-hidden="true" />
      <span className={`text-xs tracking-[0.25em] uppercase font-medium ${dark ? "text-gold" : "text-royal"}`}>
        {overline}
      </span>
    </div>
    <h2 className={`font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight ${dark ? "text-ivory" : "text-royal-deep"}`}>
      {title}
    </h2>
    {description && (
      <p className={`mt-6 text-base md:text-lg font-light leading-relaxed ${dark ? "text-ivory/70" : "text-charcoal/70"}`}>
        {description}
      </p>
    )}
  </Reveal>
);
